import { IActionCalculateEvents, IActionRemoveExpiredEvents } from '../actions/event'
import { EVENT_CALCULATE, EVENT_REMOVE_EXPIRED } from '../constants/ActionTypes'
import { Event } from '../model/Event'

type EventActions = IActionCalculateEvents | IActionRemoveExpiredEvents

const events = (state: Event[] = [], action: EventActions): Event[] => {
  switch (action.type) {
    case EVENT_CALCULATE:
      return action.events.sort((a: Event, b: Event) => a.fromDate.getTime() - b.fromDate.getTime())
    case EVENT_REMOVE_EXPIRED:
      const currentDateUnix = new Date().getTime()
      return state.filter((event: Event) => event.toDate.getTime() >= currentDateUnix)
    default:
      return state
  }
}

export default events
